import React, { useState, useContext } from 'react';
import useAsyncEffect from 'use-async-effect';
import BoardingContext from 'components/navigation/boarding/boardingContext';
import BoardingHelper from 'components/navigation/boarding/boardingHelper';
import Inputs from 'components/inputs/inputs';

export default function BoardingDealerSelection(props) {
  const { boardingState, updateDealer } = useContext(BoardingContext);
  const step = boardingState.step;

  useAsyncEffect(async () => {
    const serverDealers = await BoardingHelper.getDealers();
    if (serverDealers.length === 1) {
      updateDealer(serverDealers[0]);
      props.onSelectDealer(true);
    }
  }, []);

  if (step === BoardingHelper.enums.steps.DealerSelection) {
    return <DealerSelectionControl onSelectDealer={props.onSelectDealer} />;
  }

  return null;
}

function DealerSelectionControl(props) {
  const { updateDealer } = useContext(BoardingContext);

  const [dealers, setDealers] = useState([]);
  const [filter, setFilter] = useState('');
  const [isLoaded, setIsLoaded] = useState(false);

  useAsyncEffect(async () => {
    const serverDealers = await BoardingHelper.getDealers();
    setDealers(serverDealers);
    setIsLoaded(true);
  }, []);

  const handleSubmit = (dealer) => {
    updateDealer(dealer);
    props.onSelectDealer(false);
  };

  const filterDealers = () => {
    if (!filter || filter.length === 0) {
      return dealers;
    }
    const filterStr = filter.toLowerCase();
    return dealers.filter(d => ((d.companyName || '') + '|' + (d.branchName || '') + '|' + (d.searchTags || '')).toLowerCase().indexOf(filterStr) !== -1);
  };

  if (!isLoaded) {
    return null;
  }

  return (
    <>
      <div className='input-group'>
        <span className='input-group-prepend'>
          <div className='input-group-text'><i className='icons8-search' /></div>
        </span>
        <Inputs.Throttled placeholder='Find Dealer...' className='input' onValueChange={setFilter} />
      </div>
      <div className='table-responsive mt-4'>
        <table className='table table-striped table-hover'>
          <thead>
            <tr>
              <th>Dealership</th>
              <th>Branch</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              filterDealers().map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.companyName}</td>
                    <td>{item.branchName}</td>
                    <td className='text-right'><Inputs.Button variant='app' size='sm' onClick={() => handleSubmit(item)}>Select</Inputs.Button></td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    </>
  );
}